import { useCallback } from 'react';

import { useCurrency } from 'shared/hooks/useCurrency';
import { LOCALES } from 'localization/constants/configEnums';
import { formatMoneyObject, IFormatMoneyObjectOptions } from 'shared/utils/formatMoneyObject';

export type ICurrencyLocalizerOptions = IFormatMoneyObjectOptions;

export const useCurrencyLocalizer = (locale = LOCALES.enUS) => {
  const { selectedCurrencyCode } = useCurrency(locale);

  const localize = useCallback(
    (amount: number, options?: ICurrencyLocalizerOptions) => {
      // format money object
      const moneyObject = {
        currency: selectedCurrencyCode,
        amount,
      };

      // return formatted currency
      return formatMoneyObject(moneyObject, options);
    },
    [selectedCurrencyCode],
  );

  return { localize };
};
